export const ReportRule = [
  {id: 2, name: "month"},
  {id: 1, name: "week"},
  {id: 3, name: "day"},
  {id: 4, name: "weekTuesday"}
]
